import {UserRolesId} from "./UserRolesId";


export class UserRoles {
  constructor(
    public id?: UserRolesId,
    public recordVersion?: number,
  ){}
}



// WEBPACK FOOTER //
// ./src/app/shared/model/UserRoles.ts